import React from "react";
import styled, { css } from "styled-components";
import Section from "./Section";

const SpacerStyles = styled(Section)`
  ${({ ...props }) => css`
    height: 48px
  `}
`;

export function SpacerLandingPage({ background = 'white' }) {
  return <SpacerStyles
    grey={background === 'grey'}
    lightBlue={background === 'lightBlue'}
  />;
}
